import * as React from "react";

interface SaladIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  size?: number;
}

export const SaladIcon = React.forwardRef<SVGSVGElement, SaladIconProps>(
  ({ className, size = 38, width, height, ...props }, ref) => (
    <svg
      ref={ref}
      width={width || size}
      height={height || size}
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M19.6682 14.636C19.9552 13.089 18.8354 4.05666 17.5701 3.32633C16.2705 2.57558 14.6109 2.89 13.4063 3.982C13.3517 3.87075 13.2933 3.76141 13.2313 3.65416C11.9433 1.42175 9.31537 0.526914 7.36237 1.6545C5.5342 2.70975 4.94503 5.16266 5.93378 7.3035C4.80503 7.39216 3.7947 7.94691 3.24228 8.90416C2.2757 10.5783 3.07545 12.8492 5.02845 13.9768C5.10662 14.0217 5.18478 14.0643 5.26412 14.104"
        fill="currentColor"
      />
      <path
        d="M10.5977 7.44922C11.4017 8.31306 11.9671 9.37132 12.2381 10.5199C12.5091 11.6685 12.4765 12.8679 12.1435 14.0001"
        stroke="#090909"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5047 17.5C21.7393 19.2128 20.4544 20.6414 18.832 21.5833"
        stroke="#090909"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.76647 15.8328C2.55688 21.9217 7.9568 26.8333 14.5006 26.8333C21.0439 26.8333 26.4432 21.9217 27.2336 15.8328C27.3474 14.9578 26.6736 14.2304 25.7928 14.1867C24.097 14.1032 20.7411 14 14.5 14C8.25897 14 4.90305 14.1032 3.20788 14.1867C2.32588 14.2304 1.65272 14.9578 1.76647 15.8328Z"
        fill="white"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.7433 14.1847C26.0502 13.4688 26.1939 12.6937 26.1641 11.9154C26.1343 11.1371 25.9318 10.3752 25.5711 9.6849C25.2104 8.9946 24.7006 8.39319 24.0787 7.92429C23.4568 7.45538 22.7384 7.13072 21.9755 6.97383C21.2126 6.81694 20.4244 6.83175 19.6679 7.0172C18.9115 7.20265 18.2057 7.55409 17.6019 8.04604C16.9981 8.53799 16.5113 9.15812 16.1768 9.86149C15.8423 10.5649 15.6685 11.3338 15.668 12.1127C15.6671 12.7589 15.7857 13.3997 16.018 14.0027"
        fill="white"
      />
      <path
        d="M25.7433 14.1847C26.0502 13.4688 26.1939 12.6937 26.1641 11.9154C26.1343 11.1371 25.9318 10.3752 25.5711 9.6849C25.2104 8.9946 24.7006 8.39319 24.0787 7.92429C23.4568 7.45538 22.7384 7.13072 21.9755 6.97383C21.2126 6.81694 20.4244 6.83175 19.6679 7.0172C18.9115 7.20265 18.2057 7.55409 17.6019 8.04604C16.9981 8.53799 16.5113 9.15812 16.1768 9.86149C15.8423 10.5649 15.6685 11.3338 15.668 12.1127C15.6671 12.7589 15.7857 13.3997 16.018 14.0027"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
);

SaladIcon.displayName = "SaladIcon";
